
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/section/mtf",
      function () {
        return require("private-next-pages/section/mtf.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/section/mtf"])
      });
    }
  